import { CommonHeader } from '~/components';
import styles from './Login.module.scss';
import { useEffect, useState } from 'react';
import authApi from '~/api/authApi';
import { isSuccess } from '~/utils/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { genUniqueKey } from '~/utils/common';
import { actions, useStore } from '~/store';
import { initState } from '~/store/reducer';

function Login() {
    const [, dispatch] = useStore();
    const [showPassword, setShowPassword] = useState(false);
    const [username, setUsername] = useState('TVsk');
    const [password, setPassword] = useState('0CanPass');
    const navigate = useNavigate();

    const handleOnChangeUsername = (e) => {
        setUsername(e.target.value);
    };

    const handleOnChangePassword = (e) => {
        setPassword(e.target.value);
    };

    const handleLogin = () => {
        dispatch(actions.setLoading({ loading: true }));
        let browserId = localStorage.getItem('browserId');
        if (!browserId) {
            browserId = genUniqueKey();
            localStorage.setItem('browserId', browserId);
        }
        authApi
            .login({ username, password, browserId })
            .then((res) => {
                // console.log('res', res);
                if (isSuccess(res)) {
                    localStorage.setItem('username', username);
                    localStorage.setItem('accessToken', res.data.accessToken);
                    localStorage.setItem('refreshToken', res.data.refreshToken);
                    navigate(`/trip`);
                } else {
                    toast.error(res.data);
                }
                dispatch(actions.setLoading({ loading: false }));
            })
            .catch((error) => {
                console.log(error);
                toast.error(JSON.stringify(error));
                dispatch(actions.setLoading({ loading: false }));
            });
    };
    useEffect(() => {
        dispatch(actions.tripChange(initState));
        // eslint-disable-next-line
    }, []);
    return (
        <div className={styles.wrapper}>
            <CommonHeader title={'Đăng nhập'} />
            <div className={styles.loginForm}>
                <div className={styles.row}>
                    <div className={styles.username}>
                        <input
                            placeholder="Tên đăng nhập"
                            type="text"
                            value={username}
                            onChange={handleOnChangeUsername}
                        ></input>
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.password}>
                        <input
                            placeholder="Mật khẩu"
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={handleOnChangePassword}
                        ></input>
                        <div className={styles.showPassword}>
                            <input
                                type="checkbox"
                                name="showPassword"
                                checked={showPassword}
                                onChange={() => setShowPassword((pre) => !pre)}
                            />
                            <label
                                htmlFor="showPassword"
                                onClick={() => setShowPassword((pre) => !pre)}
                            >
                                Hiện mật khẩu
                            </label>
                        </div>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.btnLogin}>
                        <button onClick={handleLogin}>Login</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
